﻿'use strict';
var Backbone = require('backbone');
var Access = require('../models/access');

module.exports = Backbone.Collection.extend({
    model: Access
});
